export default __webpack_public_path__ + "static/media/cases-01.163e292d.jpg";